/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Disable_Confirm_TitleInputs */

const cs_portals_disable_confirm_title = /** @type {(inputs: Portals_Disable_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odebrat z portálu`)
};

const en_portals_disable_confirm_title = /** @type {(inputs: Portals_Disable_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove from portal`)
};

/**
* | output |
* | --- |
* | "Remove from portal" |
*
* @param {Portals_Disable_Confirm_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_disable_confirm_title = /** @type {((inputs?: Portals_Disable_Confirm_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Disable_Confirm_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_disable_confirm_title(inputs)
	return cs_portals_disable_confirm_title(inputs)
});